module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组方标识"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    on: {
      "change": _vm.onSubmit
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }, _vm._l((_vm.zufangLogo), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.zufangLogo
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "hidden",
      "name": "组方id"
    },
    model: {
      value: (_vm.zufangId),
      callback: function($$v) {
        _vm.zufangId = $$v
      },
      expression: "zufangId"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "icon": "edit"
    },
    on: {
      "click": _vm.handleCheck
    }
  }, [_vm._v("查看组方修改历史")]), _vm._v(" "), _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "edit"
    },
    on: {
      "click": function($event) {
        return _vm.handleCreate()
      }
    }
  }, [_vm._v("添加新组方")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "padding-left": "0px",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": "",
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "药品名称",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "数量",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row, _vm.tableData1)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.tableData1.length),
      expression: "this.tableData1.length"
    }],
    class: {
      addbutton: _vm.active
    }
  }, [_vm._v("添加一味药品：\n      "), _c('el-autocomplete', {
    class: {
      autocomplete: _vm.active
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "按药品名搜索添加"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add_Medicine
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改组方信息",
      "visible": _vm.dialogFormVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "药品名称"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.value),
      callback: function($$v) {
        _vm.$set(_vm.form, "value", $$v)
      },
      expression: "form.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", $$v)
      },
      expression: "form.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "组方修改信息",
      "visible": _vm.centerDialogVisible,
      "width": "60%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "padding-left": "0px",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.checkList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operationName",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operationDateTime",
      "label": "修改时间",
      "width": "auto"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "label": "修改类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "修改内容",
      "width": "auto"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "current-page": _vm.Current,
      "page-size": this.Size,
      "layout": "total,prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.Current = $event
      },
      "update:current-page": function($event) {
        _vm.Current = $event
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-306af1f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/project/package.vue
// module id = 1009
// module chunks = 2